import { Component, Inject, OnInit } from '@angular/core';
import { DwActionPreference, DwComponent, DwComponentType, DwExpressionService, DwFormActionConfig, DwFormActionInterceptResult, DwFormActionInterceptor, DwFormActionKeys, DwMenuService, DwMessageSeverity, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwModalButtonStandardConfigs, DwModalConfig, DwModalResult, DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken, DwSectionBaseComponent, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, DwUserEntity, getParameterByName } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CheckRideRequestEntity, CheckRideRequestPaymentPartyAllItems, CheckRideRequestSubStatusAllItems, CheckRideWorkflowAllItems, PilotExaminerEntity, SchoolFeatureAllItems, StudentApplicantWithDetailQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { Observable, of } from 'rxjs';
import { PaymentRepositoryService } from '../../services/payment-repository.service';
import { map, mergeMap, tap } from 'rxjs/operators';
import { CheckridePaymentResult } from '../../models/checkride-payment-result.model';
import { PaymentModalOptions } from '../../models/payment-modal-options.model';
import { PaymentModalComponent } from '../payment-modal/payment-modal.component';
import { CurrentStudentContext } from '../../../shared/contexts/current-student-context/current-student-context.service';
import { PaymentChargeRequest } from '../../models/payment-charge-request.model';
import { Router } from '@angular/router';
import { CheckridePaymentUtilComponent } from '../checkride-payment-util/checkride-payment-util.component';
import { CurrentPilotExaminerContext } from '../../../shared/contexts/current-pilot-examiner/current-pilot-examiner.service';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { SchoolFeatures } from '../../../schools/models/school-features.model';
import { ExaminerBookingVariableContext } from '../../../booking/models/examiner-booking-variable-context.model';

@DwComponent({
  key: 'checkride-payment-util-school',
  name: ' Checkride Payment Util School',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  isGlobal: false
})

@Component({
  selector: 'app-checkride-payment-util-school',
  template: `
    <!--<button class="btn btn-success">
      Pay Pilexos Fee
    </button>-->
  `,
})
export class CheckridePaymentUtilSchoolComponent extends CheckridePaymentUtilComponent {
  schoolFeatures: SchoolFeatures;

  ngOnInit(): void {
    super.ngOnInit();
  }

  loadRequiredData(): Observable<any>[] {
    const obs = super.loadRequiredData();

    obs.push(this.schoolRepository.getSchoolFeatures()
      .pipe(tap(features => {
        this.schoolFeatures = features;
      })));

    return obs;
  }

  protected initCheckrideCustom() {
    if (this.schoolFeatures.ForceSchoolPaymentParty && this.schoolFeatures.PilexosBookingCostPaymentPartyId) {
      
    }
  }

  private hasSchoolFreeTrial(): boolean {
    return this.schoolFeatures?.SchoolFeatures?.find(f => f == SchoolFeatureAllItems.SchoolBookingFeeFreeTrial) != null;
  }

  protected getCancelledError(): string {
    return 'Payment method was not added.';
  }

  protected processBeforeAction(actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any): Observable<DwFormActionInterceptResult> {
    const result: DwFormActionInterceptResult = {
      abort: false
    }

    const isSave = actionPref.actionKey == DwFormActionKeys.formSave || actionPref.actionKey == DwFormActionKeys.formWorkflow

    if (!isSave) {
      return of(result);
    }

    if (actionPref.actionDisplay != 'Save with Payment') {
      return of(result);
    }

    const validationResult = this.dwMetaDataFormStateService.state.formApi.validateForm();

    if (!validationResult.isValid) {
      result.abort = true;
      result.message = this.dwMetaDataFormStateService.state.formApi.createValidationMessage(validationResult);

      return of(result);
    }

    const checkrideRequest = this.dwMetaDataFormStateService.state.formApi.getFormData<CheckRideRequestEntity>();

    if (checkrideRequest.PilexosBookingPaymentAdded) {
      return of(result);
    }

    if (checkrideRequest.PilexosBookingCostPaymentPartyId != CheckRideRequestPaymentPartyAllItems.FlightSchool) {
      return of(result);
    }

    // If it's not in the correct status, update the status (this prevents it from being set to pending approval or other without payment)
    if (!checkrideRequest.CheckRideRequestId) {
      // Update the status to pending payment and save it

      switch(checkrideRequest.CheckRideWorkflowId) {
        case CheckRideWorkflowAllItems.SchoolWorkflow:
          checkrideRequest.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingApprovalPayment;
          break;
        case CheckRideWorkflowAllItems.SchoolWorkflowManualNoPilexosExaminer:
          checkrideRequest.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.AcceptedPendingPayment;
          break;
      }
    }

    // Change to always save before the payment - otherwise some fields aren't saved when the e-mail notification is sent
    return this.dwOrmDataService.saveEntity(checkrideRequest, true)
      .pipe(mergeMap(result => {
        // update the data on the form
        this.dwMetaDataFormStateService.state.formApi.patchFormData(result);

        return this.addPayment(result, this.originalCheckRideRequest);
      }));
  }



  setupCheckrideStatus(checkRideRequest: CheckRideRequestEntity, checkRideRequestPartial: Partial<CheckRideRequestEntity>, variables: ExaminerBookingVariableContext) {
    switch (checkRideRequest.CheckRideWorkflowId) {
      case CheckRideWorkflowAllItems.SchoolWorkflow:

        // School workflow always goes to pending approval on payment
        checkRideRequestPartial.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingApprovalPayment;

        if (this.hasSchoolFreeTrial() || variables.Pilexos_Payment_Waived) {
          //console.log('School has free trial - setting to Pending Approval');
          checkRideRequestPartial.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingApproval;
          checkRideRequestPartial.PilexosBookingCost = 0;
          checkRideRequestPartial.PilexosBookingPaymentAdded = true;
        }

        break;
      case CheckRideWorkflowAllItems.SchoolWorkflowManualNoPilexosExaminer:

        // School workflow always goes to pending approval on payment
        checkRideRequestPartial.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.AcceptedPendingPayment;

         if (this.hasSchoolFreeTrial() || variables.Pilexos_Payment_Waived) {
          //console.log('School has free trial - setting to Accepted');
          checkRideRequestPartial.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.Accepted;
          checkRideRequestPartial.PilexosBookingCost = 0;
          checkRideRequestPartial.PilexosBookingPaymentAdded = true;
        }
        break;
    }
  }

  protected getUpdateStatusValue(checkRideRequest: CheckRideRequestEntity) {
    if (checkRideRequest.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Cancelled) {
      return false;
    }
    return true;
  }

  protected populateChargeRequestDetails(paymentModalOptions: PaymentModalOptions) {
    const currentUser: DwUserEntity = this.context['currentUser']?.value;

    paymentModalOptions.chargeRequest.cardDetails = {} as any;
    paymentModalOptions.chargeRequest.cardDetails.cardholderName = currentUser?.FirstName + ' ' + currentUser?.LastName;
    paymentModalOptions.chargeRequest.paymentPartyId = paymentModalOptions.checkrideRequest.PilexosBookingCostPaymentPartyId;

    //paymentModalOptions.chargeRequest.cardOwnerPaymentPartyId = paymentModalOptions.chargeRequest.paymentPartyId;
    paymentModalOptions.chargeRequest.cardOwnerPaymentPartyId = CheckRideRequestPaymentPartyAllItems.FlightSchool;

    paymentModalOptions.showPaymentParty = true;
    paymentModalOptions.paymentCompleteMessage = "Your payment is complete!";

    paymentModalOptions.chargeRequest.addCardToCustomer = false;
    paymentModalOptions.chargeRequest.markDefaultCard = false;
  }
}
